import { render, staticRenderFns } from "./CompanyFinanceStatistic.vue?vue&type=template&id=72bd90fe&scoped=true&"
import script from "./CompanyFinanceStatistic.vue?vue&type=script&lang=js&"
export * from "./CompanyFinanceStatistic.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFinanceStatistic.vue?vue&type=style&index=0&id=72bd90fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd90fe",
  null
  
)

export default component.exports